'use client';

import { Card, CardMedia } from '@coolblue-development/freddy';
import goToSupportHubTrigger from '@coolblue-development/ga4-events/triggers/HelpAfterPurchase/goToSupportHubTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { Image } from '@coolblue-development/next-image/client';
import { Product } from '@features/product/typings';
import { MainProduct } from '@features/second-chance/typings';
import { useTranslation } from '@i18n/useTranslation';

export const AdviceEntrances = ({
  product,
  productSupportUrl
}: {
  product: Product | MainProduct;
  productSupportUrl: string;
}) => {
  const { t } = useTranslation('webshop');
  const { trackEvent } = useAnalytics();
  const params: Parameters<typeof goToSupportHubTrigger>[0] = {
    sub_feature: 'less_prominent',
    item_id: product.id
  };

  if (!product.hasProductSupportHub || !product.productType.image?.id) {
    return null;
  }

  return (
    <Card
      onClick={() => trackEvent(goToSupportHubTrigger(params))}
      href={productSupportUrl}
      orientation='horizontal'
      header={
        <CardMedia
          aspectRatio='1/1'
          image={
            <Image
              imageId={product.productType.image.id}
              width={200}
              height={200}
              background='transparent'
              alt='' // This image is not relevant for accessibility
              loading='lazy'
              fileCollection='content'
              objectFit='cover'
            />
          }
        />
      }
      title={t('productPage.productInformation.supportCardTitle')}
      linkProps={{ rel: 'nofollow' }}
    />
  );
};
